import $ from 'jquery';
import 'slick-carousel';

const testSliderId = 'home-hero-slider';
const $homeHeroLoadings = $('.hero-loadings');
const homeBannerOptions = $('.home__hero-stack').data('banner-options');
const isAutoscroll = homeBannerOptions?.autoscroll == true ? true : false;

const $homeHeroSlider = $(`.${testSliderId}`);

if ($homeHeroSlider.length != 0) {

$homeHeroSlider.on('init beforeChange', function (event, slick) {
  if (slick.$dots) {
    const dots = slick.$dots.find('li');
    const theme = $(`.controls-dots-${testSliderId}`).data('theme');
    dots.addClass('slick-dot ' + theme);
  }
  $homeHeroLoadings.each(function () {
    $(this).removeClass('h-0');
    $(this).removeClass('opacity-0');
  });
});

const heroSliderOptions = {
  slidesToShow: 1,
  slidesToScroll: 1,
  infinite: true,
  arrows: true,
  dots: true,
  adaptiveHeight: true,
  appendDots: $(`.controls-dots-${testSliderId}`),
  nextArrow: $(`.controls-next-${testSliderId}`),
  prevArrow: $(`.controls-prev-${testSliderId}`),
};

$homeHeroSlider.slick(heroSliderOptions);

if (isAutoscroll || true) {
  const syncVideoToInterval = homeBannerOptions?.sync_scroll ?? false; // implemented for entire slider (per slide was only a Key West specific request)
  // console.log(syncVideoToInterval);
  const duration = homeBannerOptions?.duration_interval ?? 8000;
  const RESTART = false; // not implemented here - can implement at a later time (it was a Key West specific request)
  const $nextSlideButton = isAutoscroll ? $(`.controls-next-${testSliderId}`) : $(`<button></button>`);
  let isPaused = true;
  let SLIDER_INTERVAL = 0;
  // an array of integers - each index of a slide holding an initialized video
  const initializedVideos = [];
  let APIReady = false;
  const ytPLAYERS = {};

  $homeHeroSlider.on('afterChange', function (event, slick, currentSlide) {
    // console.log('AFTER CHANGE FIRED', currentSlide);
    // console.log('current slide is: ', currentSlide)
    runSlideProgram(currentSlide);
  });

  $homeHeroSlider.on('beforeChange', function (event, slick, currentSlide, nextSlide) {
    // console.log('BEFORE CHANGE FIRED', currentSlide);
    runVideoPause(currentSlide);
  });

  // check if slider is set to restart at this slide and then slick it back to the beginning ( this banner option is currently not available)
  function checkForRestart(slideToCheck, duration = duration) {
    slideToCheck = slideToCheck + 1;
    if (RESTART) {
      // console.log('CHECKING SLIDE: ', slideToCheck);
      if (RESTART <= slideToCheck) {
        // console.log('RESTART NEEDED>>>>>>>>, going to first');
        setTimeout(function () {
          $homeHeroSlider.slick('slickGoTo', 0, true);
        }, duration);
        return true;
      }
    }
  }

  function runVideoPause(currentSlide) {
    pauseSlider();
    const video = thisSlideVideo();
    if (video) {
      const type = getVideoType(video);
      if (type == 'youtube') {
        try {
          const playerState = ytPLAYERS[currentSlide].getPlayerState();
          if (playerState !== 0) {
            // console.log('YT video is playing on this slide, pausing video ||');
            ytPLAYERS[currentSlide].pauseVideo();
          }
        } catch (err) {
          //   console.log('threw error on slide: ', currentSlide, ytPLAYERS);
        }
      } else {
        // console.log('uploaded video is playing on this slide, pausing video ||');
        video[0].pause();
      }
    }
  }

  function runSlideProgram(currentSlide) {
    // console.log('runSlideProgram: check slide for video');
    pauseSlider();
    const video = thisSlideVideo();
    // console.log('detected video: ', video);
    if (video) {
      const type = getVideoType(video);
      runVideoSlideProgram(type, video[0], currentSlide);
    } else {
      resumeSlider(currentSlide);
    }
  }

  function pauseSlider() {
    if (SLIDER_INTERVAL != 0) {
      // console.log('PAUSING interval ID: ', SLIDER_INTERVAL);
      isPaused = true;
      clearInterval(SLIDER_INTERVAL);
      SLIDER_INTERVAL = 0;
    }
  }

  
  function resumeSlider(currentSlide, forVideo = false) {
    if (!checkForRestart(currentSlide, forVideo ? 500 : duration)) {
      isPaused = false;
      if (forVideo) {
        $nextSlideButton.trigger('click');
      }
      startSliderAutoScroll();
    }
  }

  function getVideoType(video) {
    return video.hasClass('video-youtube') ? 'youtube' : 'upload';
  }

  function holdScrollForVideoEnding(video) {
    if (video) {
      return syncVideoToInterval == 1 || syncVideoToInterval == true ? false : true;
    } else {
      return false;
    }
  }

  function startSliderAutoScroll() {
    // console.log('starting slider auto scroll >>>');
    // clear any previous intervals
    if (SLIDER_INTERVAL != 0) {
      clearInterval(SLIDER_INTERVAL);
      SLIDER_INTERVAL = 0;
    }
    // start new interval
    SLIDER_INTERVAL = setInterval(function () {
      if (!isPaused) {
        $nextSlideButton.trigger('click');
      }
    }, duration);
    // console.log('STARTING interval ID: ', SLIDER_INTERVAL);
  }

  // check for any video in current slide and return it if found
  function thisSlideVideo() {
    const $thisHeroSlide = $homeHeroSlider.find('.slick-slide.slick-current');
    const $videoInThisSlide = $thisHeroSlide.find('.home-hero-video');
    return $videoInThisSlide.length != 0 ? $videoInThisSlide : false;
  }

  // check for type of video and run the relevant program
  function runVideoSlideProgram(type, video, currentSlide) {
    if (type == 'upload') {
      uploadVideoHandler(video, currentSlide);
    } else if (type == 'youtube') {
      ytVideoHandler(video, currentSlide);
    }
  }

  // program for uploaded videos
  function uploadVideoHandler(video, currentSlide) {
    // console.log('uploaded video start play');
    video.play();
    const hold = holdScrollForVideoEnding($(video));
    if (hold) {
      //   console.log('hold autoscroll for video ', hold);
      video.addEventListener('ended', function () {
        // console.log('uploaded Video ENDED');
        video.currentTime = 0;
        if (hold) {
          resumeSlider(currentSlide, true);
        } else {
          video.play();
          isPaused = false;
          startSliderAutoScroll();
        }
      });
    } else {
      setTimeout(function () {
        isPaused = false;
        startSliderAutoScroll();
      }, duration);
    }
  }

  // program for YouTube videos
  function ytVideoHandler(video, currentSlide) {
    // console.log('ytVideoHandler() called for slide', currentSlide);
    const videoId = video.getAttribute('data-video-id');
    // check whether slider needs to wait for video to finish
    const hold = holdScrollForVideoEnding($(video));
    // console.log('checking currentSlide for initialization.', currentSlide);
    // console.log('among currently initialized videos ===>', initializedVideos)
    // console.log('ytPlayer objects available to us: ', ytPLAYERS);
  
    if (initializedVideos.includes(currentSlide)) {
      // console.log('playing the existing video.');
      ytPLAYERS[currentSlide].playVideo();
      if (!hold) {
        // console.log('we are not holding slider for the video: ', hold);
        isPaused = false;
        startSliderAutoScroll();
      }
    } else if (APIReady) {
      // console.log('THIS video player needs to be initialized, creating player', currentSlide);
      ytPLAYERS[currentSlide] = new window.YT.Player(video, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
          origin: window.location.origin
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
          onError: onPlayerError,
        },
      });
      initializedVideos.push(currentSlide);
    }

    let youtubeScriptId = 'youtube-api';
    let youtubeScript = document.getElementById(youtubeScriptId);

    if (youtubeScript === null) {
        // console.log('creating API script tag!!');
      let tag = document.createElement('script');
      let firstScript = document.getElementsByTagName('script')[0];

      tag.src = 'https://www.youtube.com/iframe_api';
      tag.id = youtubeScriptId;
      firstScript.parentNode.insertBefore(tag, firstScript);
    }

    // runs only on first video
    window.onYouTubeIframeAPIReady = function () {
      // console.log('API is Ready, creating player');
      ytPLAYERS[currentSlide] = new window.YT.Player(video, {
        videoId: videoId,
        playerVars: {
          autoplay: 1,
          modestbranding: 1,
          rel: 0,
          origin: window.location.origin
        },
        events: {
          onReady: onPlayerReady,
          onStateChange: onPlayerStateChange,
          onError: onPlayerError,
        },
      });
      initializedVideos.push(currentSlide);
      APIReady = true;
      // console.log('Playe created, APIReady: ', APIReady, ' with these videos: ', initializedVideos);
    };

    function onPlayerReady(event) {
      // console.log('onPlayerReady');
      event.target.playVideo();
      if (!hold) {
        // console.log('do not hold for video: ', hold);
        isPaused = false;
        startSliderAutoScroll();
      }
    }

    function onPlayerError(event) {
      console.log('onPlayerError', event);
    }

    function onPlayerStateChange(event) {
      const state = event.data;
      if (state === YT.PlayerState.ENDED) {
        // console.log('⏸️ Video ENDED');
        if (!hold) {
          event.target.playVideo();
          isPaused = false;
          startSliderAutoScroll();
        } else {
          resumeSlider(currentSlide, true);
        }
      } else if (state === YT.PlayerState.PAUSED) {
        // console.log('⏸️ Video paused');
      } else if (state === YT.PlayerState.PLAYING) {
        // console.log('▶️ Video playing');
      }
    }
  }

  $(window).on('load', function () {
    // start auto-scroll program on page load
    startSliderAutoScroll();

    // first slide as assumed default
    runSlideProgram(0);
  });
}

}
